// Every page's content sits in one centred column on wide screens (Craig, 30 Oct 2026: Radar stretched the full
// width while the other pages didn't). The top bar and full-width bands still span the screen.
export const PAGE_WIDTH = 680;

// A block whose children sit in the column.
export const pageColumn = { maxWidth: PAGE_WIDTH, margin: "0 auto" };

// Side padding for a full-width scroll area or band: `side` px on a phone, and on a wide screen enough to keep its
// content in the column, so the scroll bar stays at the screen's edge. The content is as wide as a `pageColumn` block
// with 20px padding (Tasks, Goals) whatever `side` is, so Chat's 16px doesn't move its edge. Percentages in padding are
// of the parent's width.
const COLUMN_GUTTER = 20;
export const columnPadding = (side = COLUMN_GUTTER) => `max(${side}px, calc(50% - ${PAGE_WIDTH / 2 - COLUMN_GUTTER}px))`;

// From a tablet held sideways up, the whole app (top bar and bottom bar too) sits in one centred frame, so the bars
// stop where the page does (Craig, 2 Nov 2026: "For tablets in landscape mode and above, we should consider narrowing
// the max width of the bottom and top sections of the page"). Below WIDE_MIN nothing changes. Up to TWO_COLUMN_MIN the
// frame is the page column with a margin; from there it widens to FRAME_WIDTH for two columns.
export const WIDE_MIN = 900;
export const NARROW_FRAME_WIDTH = PAGE_WIDTH + 80;
export const FRAME_WIDTH = 1080;
// From a laptop or a sideways iPad up, a page with two parts can show them side by side (Craig, 2 Nov 2026: "on the
// today page, we could have two major columns"). Each column is 460px or more, wider than a phone.
export const TWO_COLUMN_MIN = 1000;

// The rules, drawn once by NudgeApp's style block with the theme's border colour. `frame-overlay` keeps a full-screen
// layer (Search, Help me choose) to the frame. A page splits by putting `page-columns-scroll` on its scroll area and
// `page-columns` on a block of two children. Today's `plan-head` puts "Today's Plan" beside its Radar button there.
export const frameCss = (border) => `
  @media (min-width: ${WIDE_MIN}px) {
    .app-frame, .frame-overlay { max-width: ${NARROW_FRAME_WIDTH}px; margin: 0 auto; border-left: 1px solid ${border}; border-right: 1px solid ${border}; }
  }
  @media (min-width: ${TWO_COLUMN_MIN}px) {
    .app-frame, .frame-overlay { max-width: ${FRAME_WIDTH}px; }
    .page-columns-scroll { padding-left: 32px !important; padding-right: 32px !important; }
    .page-columns { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 32px; align-items: start; }
    .plan-head { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 23px; }
    .plan-head > * { margin: 0 !important; }
  }
  @media (min-width: ${TWO_COLUMN_MIN}px) and (max-width: ${FRAME_WIDTH}px) {
    .app-frame, .frame-overlay { border-left: none; border-right: none; }
  }
`;
